import { useState } from "react";
import moment from "moment";
import Modal from "../../../components/Modal";
import InputForm from "../../../components/InputForm";

const BpjsEdit = ({ data, activeModal, closeModal, onSubmitHandler, year }) => {
  const month = moment(data?.month, "M").format("MMM");
  const yearSelect = year;

  const [paymentDate, setPaymentDate] = useState(data?.payment_date || "");
  const [note, setNote] = useState(data?.note || "");


  const submitHandler = () => {
    const payload = {
      month: data?.month,
      year: +yearSelect,
      payment_date: paymentDate,
      notes: note === "" ? null : note,
    };

    onSubmitHandler(payload);
  };

  const forms = [
    {
      margin: "mb-3",
      label: "Tanggal Pemotongan",
      type: "date",
      id: "payment_date",
      value: paymentDate,
      changeHandler: setPaymentDate,
    },
    {
      margin: "mb-3",
      label: "Note Finance",
      type: "text",
      id: "note",
      value: note,
      changeHandler: setNote,
    },
  ];

  const modalClass = activeModal ? "effect-scale show" : "";
  const modalStyle = activeModal ? { display: "block", paddingRight: "17px" } : {};

  return (
    <Modal
      activeModal={modalClass}
      activeStyle={modalStyle}
      title={`Pembayaran BPJS - ${month} ${yearSelect}`}
      closeClick={closeModal}
      submitHandler={submitHandler}
      type="Simpan"
      buttonDisable={!paymentDate}
      modalType="modal-lg"
    >
      <div className="alert alert-danger d-flex align-items-center gap-3" role="alert">
        <i className="fa fa-exclamation-triangle" style={{ fontSize: "1.5rem" }}></i>
        <div className="text-justify mb-0">
          <strong>Penting!</strong> Pembayaran akan memotong saldo deposit BPJS.
        </div>
      </div>
      <div className="alert alert-warning d-flex align-items-center gap-3" role="alert">
        <i className="fa fa-exclamation-triangle" style={{ fontSize: "1.5rem" }}></i>
        <div className="text-justify mb-0">
          <strong>Perhatian!</strong> Pembayaran yang telah dilakukan tidak dapat dibatalkan.
        </div>
      </div>

      {forms.map((form) => (
        <InputForm key={form.id} {...form} />
      ))}
    </Modal>
  );
};

export default BpjsEdit;
